import { initWidget } from '@/utils/Shell';
import MidwifeSignupFormWidget from './MidwifeSignupFormWidget.vue';

initWidget('MidwifeSignupFormWidget', MidwifeSignupFormWidget);
